import angular from 'angular';

import { ITrabalhadorLocado } from '../models/trabalhadorlocado.model';
import { ITrabalhadoresLocados } from '../models/trabalhadoreslocados.model';

import { TrabalhadoresLocadosService } from '../trabalhadoreslocados.service';
import { ListagemService } from '../../../shared/services/listagem.service';

import { SituacaoLocadosEnum } from '../enums/situacaolocados.enum';

import { Empresa, Estabelecimento, Usuario } from '../../../core/usuario/models/usuario-model';

type ITrabalhadoresLocadosListFilter = {
    empresa?: string | null;
    estabelecimento?: string | null;
    situacao?: string | null;
};

export class TrabalhadoresLocadosIndexController implements angular.IController {
    static $inject = [
        '$rootScope',
        '$scope',
        '$state',
        '$http',
        '$stateParams',
        '$location',
        '$transitions',
        'nsjRouting',
        'NewToaster',
        'TrabalhadoresLocadosService',
        '$filter',
        '$injector',
        'ListagemService'
    ];

    public entity: Partial<ITrabalhadorLocado>;
    public entities: Array<ITrabalhadoresLocados> = [];
    public busy: boolean = false;
    public entitySearchList: any = [];
    public constructors: any = [];
    public filter: any = {};
    public filters: ITrabalhadoresLocadosListFilter = {};
    public empresas: Array<Empresa>;
    public estabelecimentos: Array<Estabelecimento>;
    public exibeFiltros: boolean = false;
    public situacaoLocadosEnum = SituacaoLocadosEnum;

    constructor(
        public $rootScope: angular.IRootScopeService & {
            liberadoTela: (param: string) => boolean,
            session: any,
            nsjGlobals: any,
            usuario: Usuario
        },
        public $scope: angular.IScope,
        public $state: angular.ui.IStateService,
        public $http: angular.IHttpService,
        public $stateParams: angular.ui.IStateParamsService,
        public $location: angular.ILocationService,
        public $transitions: any,
        public nsjRouting: any,
        public NewToaster: any,
        public entityService: TrabalhadoresLocadosService,
        public $filter: any,
        public $injector: any,
        public ListagemService: ListagemService,
    ) {
        this.entityService.filter = $stateParams['q'] ? $stateParams['q'] : '';
        this.filters = this.entityService.filters = {};
        this.filter.search = $stateParams['q'];

        this.montaListagemVisibilidade();

        if (!this.$rootScope.liberadoTela('LIBERAR_LOCADOS')) {
            $state.go('dp', $stateParams);
        }

        this.$rootScope.$on('persona_locados_list_finished', (event: angular.IAngularEvent, args: any): void => {
            this.entitySearchList = [...args];
        });

        for (let i in $stateParams) {
            if (['locado', ].indexOf(i) > -1 && $stateParams[i] !== undefined) {
                this.entityService.filters[i] = $stateParams[i];
            } else if (typeof $stateParams[i] !== 'undefined' && typeof $stateParams[i] !== 'function' && i !== 'q' && i !== 'locado') {
                this.entityService.constructors[i] = $stateParams[i];
            }
        }

        $scope.$on('$destroy', (): void => {
            if (this.entityService.loading_deferred) {
                this.entityService.loading_deferred.resolve();
            }
            this.entityService.constructors = {};
        });

    }

    $onInit() {
        this.entity = {};
    }

    montaListagemVisibilidade() {
        this.filters.empresa = this.$rootScope.session.entities.empresa.empresa;
        this.filters.estabelecimento = this.$rootScope.session.entities.estabelecimento.estabelecimento;
        this.empresas = this.ListagemService.montaEmpresas(this.$rootScope.nsjGlobals.a.grupoempresarial);
        this.estabelecimentos = this.ListagemService.montaEstabelecimentos(this.filters.empresa!, this.empresas);
    }

    mudaEstabelecimentos() {
        this.estabelecimentos = this.filters.empresa ? this.ListagemService.montaEstabelecimentos(this.filters.empresa, this.empresas) : [];
        this.filters.estabelecimento = '';
        this.filtraEmpresaEstabelecimento();
    }

    filtraEmpresaEstabelecimento() {
        this.entityService.constructors['empresa'] = this.filters.empresa;
        this.entityService.constructors['estabelecimento'] = this.filters.estabelecimento;
        this.entities = this.entityService.search();
    }

    search(): Array<ITrabalhadoresLocados> {
        if (this.filter.search !== '') {
            this.$location.path(this.$location.path()).search(angular.extend({}, this.entityService.filters, { 'q': this.filter.search, }));
        } else {
            this.$location.path(this.$location.path()).search(angular.extend({}, this.entityService.filters, this.entityService.constructors));
        }

        return this.entityService.search(this.filter);
    }

    loadMore(): void {
        this.entityService.loadMore();
    }

    finished(): boolean {
        return this.entityService.loadParams.finished;
    }

    isBusy(): boolean {
        return (!this.entities || this.entities.length === 0) && this.entityService.loadParams.busy;
    }

    reload(): void {
        this.entityService.constructors['empresa'] = this.filters.empresa;
        this.entityService.constructors['estabelecimento'] = this.filters.estabelecimento;
        this.entities = this.entityService.reload();
    }

    filtraSituacao() {
        if (this.filters.situacao && this.filters.situacao !== '') {
            this.entityService.constructors['situacao'] = this.filters.situacao;
            this.entities = this.entityService.reload();
        } else {
            delete this.entityService.constructors['situacao'];
            this.entities = this.entityService.reload();
        }
    }

}
